<template>
    <div class="container-fluid login">
        <div class="row">
            <div class="col-md-12 hidden-sm hidden-xs no-float left-part-wrap">
                <div class="left-part">
                    <div class="logo">
                        <img src="../images/logo-login.svg" alt="">
                    </div>
                    <div class="title-wrap">
                        <h1 class="main-title">404 </h1>
                        <h2 class="main-sub-title">{{ $t('Houston, we have a problem.') }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {


    }
</script>
